// Import from NPM
// -------------------------------------
import React from "react";
import { Image, Loader } from "semantic-ui-react";
import { getAppConfig } from "config/client.config";

class Loading extends React.Component {
    render() {
        let isPortrait = window.innerHeight < window.innerWidth;
        let wrapperStyle = {
            height: "100vh",
            width: isPortrait ? "100%" : "100vw",
            background: getAppConfig().colors.menuColor,
            position: "relative",
            overflow: "hidden",
        };
        let logoStyle = {
            position: "absolute",
            left: isPortrait ? "50%" : "50%",
            top: "15%",
            transform: "translate(-50%,0)",
            width: "20%",
            maxWidth: "128px",
        };
        let swishStyle = {
            position: "absolute",
            left: "-10vw",
            bottom: "-10%",
            width: "120vw",
            height: "30%",
            background: getAppConfig().colors.iconColor,
            transform: "rotate(10deg)",
        };
        return (
            <div style={wrapperStyle}>
                {!getAppConfig().inductor && (
                    <Image src={getAppConfig().ui.iconlogo} style={logoStyle} />
                )}
                <Loader
                    size="massive"
                    active
                    inverted
                    style={{ marginleft: "150px" }}
                >
                    {!this.props.inGame && !this.props.offline && (
                        <p>{"LOADING YOUR CONTENT"}</p>
                    )}
                </Loader>
                <div style={swishStyle} />
            </div>
        );
    }
}

export { Loading };
